import React from 'react';
import {Box} from '@mui/material';
import {t} from 'i18next';
import ArrButton from '../../../../common/arr-button/ArrButton';

interface StepNavigationProps {
  // Button states
  isSaveDisabled?: boolean;
  isNextDisabled?: boolean;
  isBackDisabled?: boolean;

  // Button handlers
  onSave: () => void;
  onNext: () => void;
  onBack?: () => void;

  // Layout options
  showBack?: boolean;
  showHeader?: boolean;
  showFooter?: boolean;
  // When false, hides the Save button
  showSaveButton?: boolean;
  // When false, hides the Next button
  showNextButton?: boolean;
  // If true, render buttons inline without header/footer wrappers
  inline?: boolean;

  // Custom styling
  className?: string;
}

const StepNavigation: React.FC<StepNavigationProps> = ({
  isSaveDisabled = false,
  isNextDisabled = false,
  isBackDisabled = false,
  onSave,
  onNext,
  onBack,
  showBack = false,
  showHeader = true,
  showFooter = true,
  showSaveButton = true,
  showNextButton = true,
  inline = false,
  className = '',
}) => {
  const renderActionButtons = (
    showBackButton: boolean = false,
    testID: string
  ) => (
    <Box className="action-section">
      {showBackButton && onBack && (
        <Box className="left-action">
          <ArrButton
            variant="secondary"
            size="large"
            className="back-button"
            onClick={onBack}
            disabled={isBackDisabled}
            dataTestId={`${testID}-step-navigation-back-button`}
          >
            {t('common.back')}
          </ArrButton>
        </Box>
      )}
      <Box className="right-action">
        {showSaveButton && (
          <ArrButton
            variant="secondary"
            type="button"
            size="large"
            className="save-button"
            onClick={onSave}
            disabled={isSaveDisabled}
            dataTestId={`${testID}-step-navigation-save-button`}
          >
            {t('common.save')}
          </ArrButton>
        )}
        {showNextButton && (
          <ArrButton
            variant="primary"
            type="button"
            size="large"
            isAriaDisabled={isNextDisabled}
            className="next-button"
            onClick={onNext}
            dataTestId={`${testID}-step-navigation-next-button`}
          >
            {t('common.next')}
          </ArrButton>
        )}
      </Box>
    </Box>
  );

  if (inline) {
    return <Box className={className}>{renderActionButtons(showBack)}</Box>;
  }

  return (
    <>
      {showHeader && (
        <Box className={`new-production-section-header ${className}`}>
          {renderActionButtons(showBack, 'header')}
        </Box>
      )}
      {showFooter && (
        <Box className={`new-production-section-footer ${className}`}>
          {renderActionButtons(false, 'footer')}{' '}
          {/* Footer never shows back button */}
        </Box>
      )}
    </>
  );
};

export default StepNavigation;
